import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { EbAdresse } from '../../../classes/adresse';
import { Jour } from '../../../classes/jour';
import { Statique } from '../../../utils/statique';
import { EtatHoraire } from "../../../utils/enumeration";
import { StatiqueService } from '../../../services/statique.service';
import { EbUser } from '../../../classes/user';
import { CompagnieService } from '../../../services/compagnie.service';
import { SearchCriteria } from '../../../utils/searchCriteria';

@Component({
  selector: 'app-form-adresse',
  templateUrl: './form-adresse.component.html',
  styleUrls: ['./form-adresse.component.css']
})
export class FormAdresseComponent implements OnInit {

  @Input("adresse") adresse: EbAdresse;
  @Input("userConnected") userConnected: EbUser;
  @Input("displayCancelButton") displayCancelButton: boolean = false;
  @Input("enableAdvancedOpeningHours") enableAdvancedOpeningHours: boolean = false;

  @Output()
  validateAdd: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  validateEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  cancel: EventEmitter<any> = new EventEmitter<any>();

  Jour = Jour;
  Statique = Statique;
	EtatHoraire = EtatHoraire;
  listPays: any;
  listEtablissement: any;

  constructor(protected statiqueService?: StatiqueService, protected compagnieService?: CompagnieService) { }

  ngOnInit() {
    this.statiqueService.getListPays().subscribe((data) => {
      this.listPays = data;
    }); 

    var listEtablissementCritera = new SearchCriteria();
    listEtablissementCritera.ebCompagnieNum = this.userConnected.ebCompagnie.ebCompagnieNum;
        
    this.compagnieService.getListEtablisementCompagnie(listEtablissementCritera).subscribe((data) => {
      this.listEtablissement = data;
    });
  }

  fireAdd(event: any){
    this.validateAdd.next(event);
  }

  fireEdit(event: any){
    this.validateEdit.next(event);
  }

  fireCancel(event: any){
    this.cancel.next(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/adresses/form-adresse/form-adresse.component.ts